import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import IntervalManager from "./../interval-manager/IntervalManager";

export const FIRST_PARTY = "firstParty";
export const MAX_RETRIES = 3;

class Iovation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      [FIRST_PARTY]: {
        loaded: false,
        result: ""
      },
      generated: false
    };
  }

  componentDidMount() {
    const { firstParty } = this.state;
    this.setState({
      [FIRST_PARTY]: Object.assign({}, firstParty, {
        loading: true
      })
    });
  }

  sendResults() {
    const { firstParty, generated } = this.state;
    if (firstParty.loaded && !generated) {
      const finalResult = firstParty.result;
      this.setState(
        {
          finalResult,
          generated: true
        },
        () => this.props.onReceiveResults(finalResult)
      );
    }
  }

  handleScriptLoaded(type, getResult) {
    let result;
    let finished;
    let blackbox;
    try {
      result = getResult();
      finished = result.finished;
      blackbox = result.blackbox;
    } catch (e) {
      console.log(`Iovation:: failed to get result for ${type}`);
      console.log(e);
      finished = true;
      blackbox = ";";
    }
    this.setState(
      {
        [type]: {
          loaded: finished,
          loading: false,
          result: blackbox
        }
      },
      () => this.sendResults()
    );
  }

  handleFailure(type, err) {
    this.setState(
      {
        [type]: Object.assign({}, this.state[type], {
          result: ";",
          loaded: true,
          loading: false
        })
      },
      () => this.sendResults()
    );
  }

  handleFirstParty() {
    if (window.IGLOO && window.IGLOO.getBlackbox) {
      this.handleScriptLoaded(FIRST_PARTY, window.IGLOO.getBlackbox);
    }
  }

  render() {
    const { firstParty } = this.state;
    const { timeBetweenFetchInSeconds } = this.props;
    return (
      <Fragment>
        <IntervalManager
          timeBetweenFetchInSeconds={timeBetweenFetchInSeconds}
          action={this.handleFirstParty.bind(this)}
          startFetch={firstParty.loading}
          stopFetch={firstParty.loaded}
          maxRetries={MAX_RETRIES}
          onFail={err => this.handleFailure(FIRST_PARTY, err)}
        />
      </Fragment>
    );
  }
}

Iovation.defaultProps = {
  timeBetweenFetchInSeconds: 1
};

Iovation.propTypes = {
  onReceiveResults: PropTypes.func.isRequired,
  timeBetweenFetchInSeconds: PropTypes.number
};

export default Iovation;
